import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import { getAPlayerAction, clearPlayerAction } from '../store/actions';
import PlayerEdit from '../components/players/PlayerEdit';


const mapDispatchToProps = ({
    getAPlayer: getAPlayerAction,
    clearPlayer : clearPlayerAction
});


const mapStateToProps = (state) => {
    return {
        player: state.player ? state.player.data : state.player,
    }
}

const PlayerEditContainer =  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(PlayerEdit));

export default PlayerEditContainer;